var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11721476711581665195(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.9 33.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M6 3c-.5 0-1 .4-1 1v20c0 .5.4 1 1 1h32.6c.5 0 1-.4 1-1V4c0-.5-.4-1-1-1H6zm31.3 19.8h-30V5.1h30.1v17.7zM39.3 25.4H5.4c-.2 0-.4.1-.6.3l-3.4 3.2c-.7.7-.3 2 .6 2h40.7c.9 0 1.3-1.3.6-2l-3.4-3.2c-.2-.2-.4-.3-.6-.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.3 22.8V5.1h-30v17.7h30zM22 16.5h-6.5v-.8H22v.8zm7.4 4.4h-7v-.6h7v.6zm6.4-1H22.4v-.6h13.4v.6zm0-1.1H22.4v-.6h13.4v.6zm0-1H22.4v-.6h13.4v.6zm-13.4-1.3v-.8h6.5v.8h-6.5zm13.4 0h-6.5v-.8h6.5v.8zM8.6 6.6h27.2v8.3H8.6V6.6zm0 9.1h6.5v.8H8.6v-.8zm0 1.5H22v4.1H8.6v-4.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M8.6 6.6h27.2v8.3H8.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#82BFAB",
    d: "M8.6 15.7h6.5v.8H8.6zM8.6 17.2H22v4.1H8.6zM15.5 15.7H22v.8h-6.5zM22.4 15.7h6.5v.8h-6.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M22.4 17.2h13.4v.6H22.4zM22.4 18.2h13.4v.6H22.4zM22.4 19.3h13.4v.6H22.4zM22.4 20.3h7v.6h-7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#82BFAB",
    d: "M29.3 15.7h6.5v.8h-6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11721476711581665195);
export default __webpack_public_path__ + "static/media/11721476711581665195.837fa75ee550036c3e6229f6aebd7c6d.svg";
export { ForwardRef as ReactComponent };